import { BaseUrl } from "../../../BaseUrl";




export const GET_WEB_DB_T_ExaminationFormMainCount_SelectAPI = ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        T_ExaminationFormID,
        M_MainSubjectID,
        M_SubSubjectID,
        OptionalSub_M_IndicatorID,
        Flag,
        M_UserID,
        token,
        setisLoading,
        handleSetLicentiateCount,
        handleSetAssociateCount,
        handleSetFellowCount,
        handlesetSpecialisedData
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    setisLoading(true)
    fetch(`${BaseUrl}/Transaction/GET_WEB_DB_T_ExaminationFormMainCount_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&T_ExaminationFormID=${T_ExaminationFormID}&M_MainSubjectID=${M_MainSubjectID}&M_SubSubjectID=${M_SubSubjectID}&OptionalSub_M_IndicatorID=${OptionalSub_M_IndicatorID}&M_UserID=${M_UserID}&Flag=${Flag}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                if (result?.data?.licentiate && result?.data?.licentiate.length > 0) {
                    handleSetLicentiateCount(result?.data?.licentiate)
                }
                if (result?.data?.associate && result?.data?.associate.length > 0) {
                    handleSetAssociateCount(result?.data?.associate)
                }
                if (result?.data?.fellow && result?.data?.fellow.length > 0) {
                    handleSetFellowCount(result?.data?.fellow)
                }
                if ( result?.data?.specialisedDiploma) {
                    handlesetSpecialisedData( result?.data?.specialisedDiploma)
                }
                setisLoading(false)
            } else {
                setisLoading(false)
            }
        })
        .catch((error) => {
            console.error(error)
            setisLoading(false)
        })
}


export const OptionalGet_SelectAPI = ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        T_ExaminationFormID,
        M_MainSubjectID,
        M_SubSubjectID,
        OptionalSub_M_IndicatorID,
        Flag,
        M_UserID,
        token,
        setisLoading,
        handleGetData,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    setisLoading(true)
    fetch(`${BaseUrl}/Transaction/GET_WEB_DB_T_ExaminationFormMainCount_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&T_ExaminationFormID=${T_ExaminationFormID}&M_MainSubjectID=${M_MainSubjectID}&M_SubSubjectID=${M_SubSubjectID}&OptionalSub_M_IndicatorID=${OptionalSub_M_IndicatorID}&M_UserID=${M_UserID}&Flag=${Flag}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                if (result?.data?.table && result?.data?.table.length > 0) {
                    handleGetData(result?.data?.table)
                }
                setisLoading(false)
            } else {
                setisLoading(false)
            }
        })
        .catch((error) => {
            console.error(error)
            setisLoading(false)
        })
}